document.addEventListener('DOMContentLoaded', function () {
    const faqButtons = document.querySelectorAll(".article__faq-item");

    faqButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const answer = button.nextElementSibling;
            const isExpanded = button.getAttribute("aria-expanded") === "true";
            const icon = button.querySelector(".article__faq-icon");

            button.setAttribute("aria-expanded", String(!isExpanded));
            answer.hidden = isExpanded;
            icon.textContent = isExpanded ? "+" : "−";
        });
    });
})

